import { render } from "./ClientLogDetailView.vue?vue&type=template&id=41fa76b9&scoped=true"
import script from "./ClientLogDetailView.vue?vue&type=script&lang=js"
export * from "./ClientLogDetailView.vue?vue&type=script&lang=js"

import "./ClientLogDetailView.vue?vue&type=style&index=0&id=41fa76b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fa76b9"]])

export default __exports__